import React, { useEffect, useState } from "react";
import executeRequest from "../../modules/request.js";
import LoadingComponent from "../../shared/ui/animations/loading.js";
import Button from "../../shared/ui/inputs/classicButton.js";
import CorrectInfo from "../../shared/ui/login/correctInfo.js";
import RedText from "../../shared/ui/login/redInfo.js";
export default function AccountCreated(props) {
    const [emailCount, setEmailCount] = useState(10);
    const [isSending, setSending] = useState(false);
    const [error, showError] = useState("");
    const [success, showSuccess] = useState("");
    useEffect(() => {
        executeRequest("/api/public/unverifiedMerchants/emailCountLimit", "GET", {}).then((res) => {
            if (res.status === 200) {
                setEmailCount(res.countLimit);
                return;
            }
            showSuccess("");
            showError("Użytkownik nie jest zalogowany");
        });
    }, []);
    useEffect(() => {
        showSuccess("");
        if (emailCount <= 0) {
            showError("Przekroczono limit wysyłanych e-maili");
            return;
        }
        setSending(true);
        executeRequest(`/api/public/unverifiedMerchants/sendEmailToVerify?email=${props.email}`, "GET", {}).then((res) => {
            setSending(false);
            if (res.status == 200) {
                showSuccess("Email wysłany!");
                return;
            }
            showError("Serwer napotkał problem");
        });
    }, [emailCount]);
    return (React.createElement("main", { className: "create_account-main" },
        React.createElement("div", { className: "create_account-container" },
            React.createElement("h2", null, "Konto utworzono pomy\u015Blnie!"),
            React.createElement("div", { className: "flex-container-column" },
                React.createElement("h3", null,
                    "Na podany adres email zosta\u0142a wys\u0142ana",
                    React.createElement("br", null),
                    "wiadomo\u015B\u0107 weryfikacyjna."),
                React.createElement(Button, { version: "classic", value: "send_email_again", onClick: () => {
                        setEmailCount(emailCount - 1);
                    }, text: "Wy\u015Blij ponownie" }, isSending ?
                    React.createElement(LoadingComponent, { color: "white" })
                    : null),
                React.createElement(RedText, { text: error }),
                React.createElement(CorrectInfo, { text: success })))));
}
